import { putData, postData } from "../../../../../services/library";
import { enviarmails, logEventos } from "../../../../../services/services";
import { UrlApi } from "../../../../../services/apirest";
// Valida la lista de materiales para identificar ítems pendientes
export async function validarOrdenCompra(
  e,
  listaMateriales,
  setPendientes,
  reqMaterial,
  setmodalListaPendiente,
  callback,
  setNotificacion,
  setIsProcessing,
  setModalOtrosPendientes
) {
  e.preventDefault();
  try {
    if (!Array.isArray(listaMateriales) || listaMateriales.length === 0) {
      setPendientes([]);
      setNotificacion({
        open: true,
        mensaje: 'La lista de materiales está vacía o es inválida',
        severity: 'error',
        color: '#FADBD8',
      });
      return;
    }

    const pendientes = listaMateriales.map((item) => {
      const cantidad = parseFloat(item.cantidad ?? 0) || 0;
      const cantidadActualizada = parseFloat(item.cantidad_actualizada ?? 0) || 0;
      const subtotal = parseFloat(item.subtotal ?? 0) || 0;
      const noComprado = !subtotal || subtotal === 0;
      const cantidadInsuficiente = subtotal > 0 && cantidad > cantidadActualizada;

      if (noComprado || cantidadInsuficiente) {
        return {
          ...item,
          cantidad,
          cantidad_actualizada: cantidadActualizada,
          cantidadFaltante: noComprado ? cantidad : cantidad - cantidadActualizada,
          subtotal,
          id_articulo: item.id_articulo || null,
          material: item.material || item.nombre || 'Sin nombre',
          id_unidad_medida: item.id_unidad_medida || null,
          uuid_requerimiento: item.uuid_requerimiento || null,
        };
      }
      return null;
    }).filter(Boolean);

    const pendientesActuales = pendientes.filter(
      (p) => p.uuid_requerimiento === reqMaterial.uuid_requerimiento
    );
    const pendientesDeOtros = pendientes.filter(
      (p) => p.uuid_requerimiento !== reqMaterial.uuid_requerimiento
    );

    setPendientes(pendientesActuales);

    if (pendientesActuales.length > 0) {
      setmodalListaPendiente(true); // abrir modal original
      setIsProcessing(false);
    } else if (pendientesDeOtros.length > 0) {
      setModalOtrosPendientes(true); // abrir el nuevo modal para advertir
      setIsProcessing(false);
    } else {
      callback(); // no hay pendientes de ningún tipo
    }
  } catch (error) {
    console.error('Error en validarOrdenCompra:', error);
    setNotificacion({
      open: true,
      mensaje: 'Error al validar la lista de materiales',
      severity: 'error',
      color: '#FADBD8',
    });
  }
}

export const orchestrateTransaction = async (
  e,
  listaMateriales,
  pendientes,
  proveedorSelected,
  datosFormulario,
  condVentaNew,
  totalFinal,
  bonificacionPesos,
  bonificacionPorcentaje,
  datosRequerimiento,
  observacionesReq,
  empSelected,
  handleClose,
  usuarioSelected
) => {

  const {
    id,
    id_sucursal,
    uuid_requerimiento,
    estado,
    uuid_ordencompra,
  } = datosRequerimiento;

  try {
    // 🔵 Crear orden de compra
    const responseOC = await fetch(`${UrlApi}/ordencompra`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id_estado: 89,
        uuid_ordencompra: datosFormulario.uuid_ordencompra,
        id_proveedor: proveedorSelected.id,
        fecha_entrega: datosFormulario.fecha_entrega || null,
        comentarios_internos: datosFormulario.comentarios_internos || "",
        facturar_a_empresa: empSelected,
        condicion_venta: condVentaNew,
        total: totalFinal,
        bonificacion_pesos: bonificacionPesos,
        bonificacion_porcentaje: bonificacionPorcentaje,
        iva_incluido: datosFormulario.iva_incluido,
        tipo_moneda: datosFormulario.tipo_moneda,
        pago_anticipado: datosFormulario.pago_anticipado,
        id_sucursal,
        id_vehiculo: datosFormulario.id_vehiculo,
        saldo_pendiente: 1,
        usuario: localStorage.getItem("user"),
        origen: "requerimiento",
        usuario_autoriza: usuarioSelected
      })
    });

    const dataOC = await responseOC.json();

    // Avisar al usuario con el número de OC
    alert(`Se creó la OC Nº ${dataOC.nro_oc}`);

    handleClose()

    enviarmails(
      usuarioSelected.email,
      "Solicitud de orden de compra.",
      `<p>Se generó una nueva solicitud de orden de compra.</p>`
    );

    // 🔵 Crear lista de materiales
    const pendientesActuales = pendientes.filter(
      (p) => p.uuid_requerimiento === uuid_requerimiento
    );

    const datosLista = pendientesActuales.map((item) => ({
      cantidad: item.cantidadFaltante,
      usuario: localStorage.getItem("usuario"),
      uuid_requerimiento,
      uuid_ordencompra: null,
      precio_unitario: null,
      id_articulo: item.id_articulo || null,
      subtotal: null,
      bonificacion_pesos: null,
      bonificacion_porcentaje: null,
      cantidad_actualizada: null,
      material: item.material || item.nombre,
      id_unidad_medida: item.id_unidad_medida || null,
    }));

    if (datosLista.length > 0) {
      await fetch(`${UrlApi}/lista_materiales`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ datosLista })
      });
    }

    const nuevoEstado = pendientesActuales.length > 0 ? 313 : 58;
    const nuevoUuidOrdenCompra =
      estado === 313 && uuid_ordencompra
        ? `${uuid_ordencompra},${datosFormulario.uuid_ordencompra}`
        : datosFormulario.uuid_ordencompra;

    const esFechaValida = !isNaN(new Date(datosFormulario.fecha_entrega).getTime());

    // Actualizar requerimiento
    await fetch(`${UrlApi}/uploadfiles/${uuid_requerimiento}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ uuid_ordencompra: nuevoUuidOrdenCompra }),
    });

    await fetch(`${UrlApi}/requerimientos_materiales/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        estado: nuevoEstado,
        uuid_ordencompra: nuevoUuidOrdenCompra,
        fecha_entrega: esFechaValida ? datosFormulario.fecha_entrega : null,
        comentarios_internos: observacionesReq
      })
    });


  } catch (error) {
    console.error("Error en orchestrateTransaction:", error);
  }
};